// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ICustomActionSchema } from '../custom_action/CustomActionSchema';
import type { IMessageInChatListSchema } from './MessageInChatListSchema';
import type { IUserInChatListSchema } from './UserInChatListSchema';

export interface IChatDataInListSchema {
  /** Чат архивирован **/
  archived: boolean;
  /** Доступные действия над чатом **/
  availableActions?: EAvailableActions[];
  /** Чат заблокирован **/
  blocked: boolean;
  /** Идентификатор чата **/
  chatId: string;
  /** Таймстемп создания чата **/
  created: number;
  /** Таймстемп создания чата(c точностью до ms) **/
  createdMs: number;
  /** Кастомные действия для чатов **/
  customActions?: ICustomActionSchema[];
  /** Данные чата/обновления **/
  data?: object;
  /** Чат удален **/
  deleted: boolean;
  /** Описание чата. Например, '2-комн. кв. ･ 5,2 млн ₽ ･ р-н Ленинградский' **/
  description?: string;
  /** Последнее сообщение **/
  message: IMessageInChatListSchema;
  /** Название чата (всегда пустое, нужно только для поддержки схемы) **/
  title?: string;
  /** Тип чата **/
  type: EType;
  /** Кол-во непрочитанных сообщений **/
  unread: number;
  /** Таймстемп обновления чата **/
  updated: number;
  /** Таймстемп обновления чата(с точностью до ms) **/
  updatedMs: number;
  /** Участники чата **/
  users: IUserInChatListSchema[];
  /** Чат между модератором и пользователем **/
  withModerator: boolean;
}
export enum EAvailableActions {
  /** Пользователь может переместить чат в архив **/
  'Archive' = 'archive',
  /** Пользователь может заблокировать чат (бывший спам) **/
  'Block' = 'block',
  /** Пользователь может удалить чат **/
  'Delete' = 'delete',
  /** Пользователь может разархивировать чат **/
  'Restore' = 'restore',
  /** Пользователь может отправить файлы в чат **/
  'SendFile' = 'sendFile',
  /** Пользователь может отправить сообщение в чат **/
  'SendMessage' = 'sendMessage',
  /** Пользователь может разблокировать чат (бывший спам) **/
  'Unblock' = 'unblock',
}
export enum EType {
  /** Чат между двумя пользователями по карточке агента **/
  'Agent' = 'agent',
  /** Чат между двумя пользователями по объявлению **/
  'Offer' = 'offer',
}
